import styled from 'styled-components';
import {
  ContainerMarginSections,
  DisplayTitle,
  SectionLabel,
  ScriptAccent,
  Colors,
  fonts,
} from '../style/GlobalStyles';

const Head = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 3rem;
  margin-bottom: 4rem;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1.5rem;
    margin-bottom: 2.5rem;
  }
`;

const List = styled.div`
  display: flex;
  flex-direction: column;
`;

const Row = styled.div`
  display: grid;
  grid-template-columns: 60px 1fr 1.3fr;
  align-items: center;
  gap: 2rem;
  padding: 2.2rem 0;
  border-top: 1px solid ${Colors.line};

  &:last-child {
    border-bottom: 1px solid ${Colors.line};
  }

  @media (max-width: 768px) {
    grid-template-columns: 40px 1fr;
    gap: 1rem 1.2rem;
    padding: 1.6rem 0;
  }
`;

const Num = styled.span`
  font-family: ${fonts.body};
  font-size: 1rem;
  color: ${Colors.muted};
`;

const SectorName = styled.h3`
  font-family: ${fonts.display};
  text-transform: uppercase;
  font-weight: 400;
  font-size: clamp(1.4rem, 3vw, 2.2rem);
  color: ${Colors.ink};
  margin: 0;
  letter-spacing: 0.5px;
`;

const Desc = styled.p`
  font-family: ${fonts.body};
  font-size: 1rem;
  line-height: 1.6;
  color: ${Colors.muted};
  margin: 0;

  @media (max-width: 768px) {
    grid-column: 2 / -1;
  }
`;

const Closing = styled.div`
  display: flex;
  align-items: center;
  gap: 1.5rem;
  margin-top: 4rem;

  .bullet {
    width: 26px;
    height: 26px;
    border-radius: 50%;
    background: ${Colors.ink};
    flex-shrink: 0;
  }
`;

const Skills = ({ skills = [] }) => {
  return (
    <ContainerMarginSections>
      <Head>
        <SectionLabel className="gsap-fade-up">Expertise</SectionLabel>
        <DisplayTitle className="gsap-fade-up">
          How I solve
          <br />
          your challenges
        </DisplayTitle>
      </Head>

      <List>
        {skills.map((sector, i) => (
          <Row className="gsap-fade-up" key={sector.sector}>
            <Num>{String(i + 1).padStart(2, '0')}</Num>
            <SectorName>{sector.sector}</SectorName>
            <Desc>{sector.skills.map((s) => s.name).join(' · ')}</Desc>
          </Row>
        ))}
      </List>

      <Closing className="gsap-fade-up">
        <span className="bullet" />
        <ScriptAccent>Turning ideas into systems that scale</ScriptAccent>
      </Closing>
    </ContainerMarginSections>
  );
};

export default Skills;
